var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.205 6.15998H23.7521C23.9914 5.62945 24.1409 5.01051 24.1409 4.39156C24.1409 1.97473 22.1367 0 19.6837 0C16.6922 0 15.1965 1.67999 13.9999 3.65472C12.8034 1.67999 11.3077 0 8.31621 0C5.86323 0 3.85896 1.97473 3.85896 4.39156C3.85896 5.01051 4.00853 5.62945 4.24785 6.15998H1.79487C0.807689 6.15998 0 6.95577 0 7.92839V11.5242C0 11.9957 0.388887 12.3789 0.867518 12.3789H27.1324C27.611 12.3789 27.9999 11.9957 27.9999 11.5242V7.92839C27.9999 6.95577 27.1922 6.15998 26.205 6.15998ZM19.6837 2.62315C20.6709 2.62315 21.4786 3.41894 21.4786 4.39156C21.4786 5.36419 20.6709 6.15998 19.6837 6.15998H15.6153C16.9316 3.77262 17.7093 2.62315 19.6837 2.62315ZM6.52134 4.39156C6.52134 3.41894 7.32903 2.62315 8.31621 2.62315C10.2906 2.62315 11.0683 3.77262 12.3846 6.15998H8.31621C7.32903 6.15998 6.52134 5.36419 6.52134 4.39156Z",
    fill: "#999FA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79486 25.8189C1.79486 27.0273 2.78204 27.9999 4.00853 27.9999H12.6837V15.0021H1.79486V25.8189Z",
    fill: "#999FA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3162 27.9999H23.9914C25.2179 27.9999 26.205 27.0273 26.205 25.8189V15.0021H15.3162V27.9999Z",
    fill: "#999FA4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/icon_gift.b41cc35a29adeb4ce95a29ec2d8f692c.svg";
export { ForwardRef as ReactComponent };